import { useState } from "react";

export const useNavItemData = (openProp) => {
  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return {
    open,
    handleToggle,
  };
};
